import React from "react";
import styled from "styled-components";
import Tooltip from "../tooltip/Tooltip";

const AddActionInKanbanButton = ({setOpenModal}) => {

    const addNewAction = () => {
        setOpenModal(true)
    }

    return (
        <Tooltip direction={"bottom"} content={"Ajouter une action"}>
            <Button onClick={addNewAction} className={"edit-btn"} id={"edit-btn"}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.124 2.04752C16.0153 2.0269 16.7421 2.35733 17.1837 3.1397C17.4079 3.53693 17.5482 3.9938 17.6585 4.44035C17.8652 5.2801 17.9172 6.14452 17.9051 7.00624C17.8948 7.75811 17.7441 8.49609 17.5733 9.22735C17.4868 9.59723 17.3639 9.9595 17.2931 10.3316C17.1783 10.9347 16.9618 11.5014 16.6833 12.0389C16.5062 12.381 16.2498 12.6841 16.014 12.993C15.9736 13.0459 15.8494 13.0742 15.7777 13.0571C14.9411 12.8558 14.1076 12.6402 13.2714 12.4362C13.0163 12.3738 12.7554 12.3339 12.4962 12.2878C12.3111 12.2546 12.1748 12.1689 12.108 11.9829C11.8851 11.3637 11.7479 10.7248 11.6672 10.0729C11.5637 9.23676 11.5157 8.39566 11.5843 7.55636C11.7094 6.02167 12.0613 4.55154 12.9522 3.25896C13.2759 2.78909 13.6875 2.40531 14.2286 2.204C14.5102 2.09953 14.8182 2.06591 15.1146 2L15.1244 2.04663L15.124 2.04752Z"
                        fill="#3394F6"/>
                    <path
                        d="M10.3446 11.1761C10.3338 12.2539 10.2527 13.2004 10.0299 14.1298C9.9671 14.3912 9.87429 14.6454 9.79404 14.9023C9.73979 15.0767 9.60977 15.1677 9.44164 15.2103C8.35619 15.4824 7.26985 15.7523 6.18485 16.0263C6.07635 16.0536 5.99565 16.0357 5.91315 15.9563C5.61321 15.6685 5.4119 15.3148 5.24108 14.9453C4.72862 13.8357 4.40132 12.6677 4.19329 11.467C4.10048 10.9326 4.0014 10.3897 4.00005 9.85031C3.99781 8.88367 4.06506 7.91659 4.35245 6.98178C4.48561 6.54913 4.67033 6.14069 4.96938 5.79456C5.54685 5.12653 6.29649 4.92298 7.14386 5.02475C7.92354 5.11846 8.47142 5.58832 8.9229 6.18731C9.42326 6.85132 9.71916 7.61306 9.94379 8.40573C10.2119 9.35175 10.3621 10.3139 10.3442 11.1752L10.3446 11.1761Z"
                        fill="#3394F6"/>
                    <path
                        d="M10.9022 18.8487C10.9031 19.4364 10.7712 19.9861 10.4112 20.4582C9.73601 21.3442 8.57569 21.4347 7.71621 20.6784C7.17909 20.2058 6.83028 19.6041 6.65004 18.9276C6.49177 18.334 6.42631 17.7157 6.31781 17.1082C6.29854 16.9992 6.35323 16.9589 6.44694 16.9311C7.36202 16.6558 8.27664 16.3783 9.19082 16.0998C9.36254 16.0474 9.53381 15.9922 9.70194 15.9304C9.7952 15.8963 9.85303 15.9039 9.91177 15.9958C10.3906 16.7423 10.7556 17.5332 10.8721 18.4218C10.8905 18.5631 10.8923 18.7061 10.9022 18.8487Z"
                        fill="#3394F6"/>
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M11.6414 13.6256C11.2679 14.3354 11.0092 15.0787 11.0003 16.0987V16.0983C10.9944 16.3449 11.0895 16.7744 11.293 17.1788C11.6538 17.8952 12.3334 18.2853 13.0613 18.2153C13.021 18.4709 13 18.733 13 19C13 21.76 15.24 24 18 24C20.76 24 23 21.76 23 19C23 16.24 20.76 14 18 14C17.1164 14 16.2862 14.2296 15.5656 14.6323C15.5891 14.4654 15.6088 14.2974 15.6259 14.1287C15.6371 14.0197 15.5792 13.9928 15.4972 13.9682L15.4245 13.9462C14.3413 13.6191 13.2577 13.2918 12.1763 12.9594C12.0853 12.9316 12.0395 12.9491 11.9956 13.0249C11.9528 13.0983 11.9084 13.1709 11.864 13.2435C11.7869 13.3695 11.7099 13.4954 11.6414 13.6256ZM18.5 19.5H20C20.275 19.5 20.5 19.275 20.5 19C20.5 18.725 20.275 18.5 20 18.5H18.5V17C18.5 16.725 18.275 16.5 18 16.5C17.725 16.5 17.5 16.725 17.5 17V18.5H16C15.725 18.5 15.5 18.725 15.5 19C15.5 19.275 15.725 19.5 16 19.5H17.5V21C17.5 21.275 17.725 21.5 18 21.5C18.275 21.5 18.5 21.275 18.5 21V19.5Z"
                          fill="#3394F6"/>
                </svg>
            </Button>
        </Tooltip>

    )
}

const Button = styled.button`
  border: none;
  padding: 0.2em;
  cursor: pointer;
  background: transparent;
  border-radius: 50%;
  height: 36px;
  width: 36px;

  &:hover {
    background: var(--color-blue-06);

    svg {

      path {
        fill: white;
      }

      path:last-of-type {
        fill: white;
      }
    }
  }
`
export default AddActionInKanbanButton;